import { Component } from "@angular/core";
import { Platform, LoadingController, AlertController } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { WalkthroughPage } from "../pages/walkthrough/walkthrough";
import { AngularFireAuth } from "angularfire2/auth";
import { HeaderColor } from "@ionic-native/header-color";
import { SettingsProvider } from "./../providers/settings/settings";
import * as firebase from "firebase";
import { UserProvider } from "../providers/user/user";
import { NetworkProvider } from "../providers/network/network";
import { Diagnostic } from "@ionic-native/diagnostic";
import { Storage, IonicStorageModule } from "@ionic/storage";
import { Environment } from "../environment/environment";
import { ToastProvider } from "../providers/toast/toast";
import { Network } from "@ionic-native/network";
import { Device } from "@ionic-native/device";
import {
  ThreeDeeTouch,
  ThreeDeeTouchQuickAction,
  ThreeDeeTouchForceTouch
} from "@ionic-native/three-dee-touch";
import { SuperTabsController } from "ionic2-super-tabs";
import { Keyboard } from "@ionic-native/keyboard";
import { FcmProvider } from "../providers/fcm/fcm";
import { Subject } from "rxjs/Subject";
import { tap } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "app.html"
})
export class MyApp {
  showWalkthrough: boolean;
  selectedTheme: String;
  rootPage: any;
  public user: firebase.User;

  constructor(
    public userservice: UserProvider,
    public auth: UserProvider,
    private settings: SettingsProvider,
    private headerColor: HeaderColor,
    private loadingCtrl: LoadingController,
    private afAuth: AngularFireAuth,
    public platform: Platform,
    public splashScreen: SplashScreen,
    public alertCtrl: AlertController,
    private networkProvider: NetworkProvider,
    public diagnostic: Diagnostic,
    public storage: Storage,
    public toast: ToastProvider,
    public network: Network,
    private threeDeeTouch: ThreeDeeTouch,
    private superTabsCtrl: SuperTabsController,
    public device: Device,
    private keyboard: Keyboard,
    public fcm: FcmProvider
  ) {
    console.clear();
    if (this.network.type != "none") {
      this.settings.getActiveTheme().subscribe(val => {
        this.selectedTheme = val;
      });
      this.showWalkthrough = Environment.showWalkthrough;
      if (this.showWalkthrough) {
        if (
          this.device.model != null &&
          this.device.model.indexOf("iPad") > -1
        ) {
          this.rootPage = "LoginPage";
        } else {
          this.rootPage = WalkthroughPage;
        }
      } else {
        this.rootPage = "LoginPage";
      }
      this.initializeApp();
      this.auth.getUser().then((user: firebase.User) => {
        this.user = user;
        this.afAuth.authState.subscribe(auth => {
          if (auth) {
            if (!this.user.emailVerified) {
              this.rootPage = "VerificationPage";
            } else {
              this.rootPage = "TabsPage";
              this.superTabsCtrl.showToolbar(true);
              if (!this.platform.is("mobileweb")) {
                if (
                  this.platform.is("ios") ||
                  this.platform.is("android") ||
                  this.platform.is("windows")
                ) {
                  this.fcm.getToken();
                  this.fcm
                    .listenToNotifications()
                    .pipe(
                      tap(msg => {
                        // const toast = this.toast.quickShow(msg.body);
                      })
                    )
                    .subscribe();
                }
              }
              console.clear();
            }
          } else {
            if (this.showWalkthrough) {
              if (
                this.device.model != null &&
                this.device.model.indexOf("iPad") > -1
              ) {
                this.rootPage = "LoginPage";
              } else {
                this.rootPage = WalkthroughPage;
              }
            } else {
              this.rootPage = "LoginPage";
            }
          }
        });
      });
    } else {
      this.presentAlert();
    }
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: "No Internet Connection!",
      message:
        "NativeChain requires an internet connection, please connect to a network.",
      buttons: [
        {
          text: "Try Again",
          handler: () => {
            if (this.network.type == "none") {
              this.presentAlert();
            } else {
              this.settings.getActiveTheme().subscribe(val => {
                this.selectedTheme = val;
              });
              this.showWalkthrough = Environment.showWalkthrough;
              if (this.showWalkthrough) {
                if (
                  this.device.model != null &&
                  this.device.model.indexOf("iPad") > -1
                ) {
                  this.rootPage = "LoginPage";
                } else {
                  this.rootPage = WalkthroughPage;
                }
              } else {
                this.rootPage = "LoginPage";
              }
              this.initializeApp();
              this.auth.getUser().then((user: firebase.User) => {
                this.user = user;
                this.afAuth.authState.subscribe(auth => {
                  if (auth) {
                    if (!this.user.emailVerified) {
                      this.rootPage = "VerificationPage";
                    } else {
                      this.rootPage = "TabsPage";
                    }
                  } else {
                    if (this.showWalkthrough) {
                      if (
                        this.device.model != null &&
                        this.device.model.indexOf("iPad") > -1
                      ) {
                        this.rootPage = "LoginPage";
                      } else {
                        this.rootPage = WalkthroughPage;
                      }
                    } else {
                      this.rootPage = "LoginPage";
                    }
                  }
                });
              });
            }
          }
        },
        {
          text: "Open Settings",
          handler: () => {
            this.diagnostic.switchToWifiSettings();
            this.presentAlert();
          }
        }
      ]
    });
    alert.present();
  }

  initializeApp() {
    this.headerColor.tint("#f7b967");
    this.platform.ready().then(() => {
      // this.initialize3d();
      // this.keyboard.disableScroll(true);
      this.splashScreen.hide();
    });
  }

  initialize3d() {
    this.threeDeeTouch
      .watchForceTouches()
      .subscribe((data: ThreeDeeTouchForceTouch) => {});
    let actions: Array<ThreeDeeTouchQuickAction> = [
      {
        type: "scan",
        title: "Scan Item",
        iconType: "Share"
      },
      {
        type: "view",
        title: "View Blockchain",
        iconType: "Search"
      }
    ];
    this.threeDeeTouch.configureQuickActions(actions);

    document.addEventListener(
      "deviceready",
      function() {
        this.threeDeeTouch.onHomeIconPressed().subscribe(payload => {
          if (payload.type == "scan") {
            this.superTabsCtrl.slideTo(0);
          } else if (payload.type == "view") {
            this.superTabsCtrl.slideTo(1);
          }
        });
      },
      false
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts